import { db } from "../Firebase";
import { doc, getDoc, setDoc, updateDoc, collection, addDoc, serverTimestamp } from "firebase/firestore";

export const getPortfolioData = async () => {
  const docRef = doc(db, "portfolioData", "main");
  const docSnap = await getDoc(docRef);
  return docSnap.exists() ? docSnap.data() : null;
};

export const savePortfolioData = async (data) => {
  const docRef = doc(db, "portfolioData", "main");
  await setDoc(docRef, data, { merge: true });
};

export const saveSectionData = async (sectionKey, data) => {
  const docRef = doc(db, "portfolioData", "main");
  // Single write in the common path (document already exists).
  // Falls back to setDoc only on first-ever save when the document doesn't exist yet.
  try {
    await updateDoc(docRef, {
      ...data,
      [`_meta.${sectionKey}.updatedAt`]: serverTimestamp(),
    });
  } catch (err) {
    if (err.code === "not-found") {
      await setDoc(docRef, {
        ...data,
        _meta: { [sectionKey]: { updatedAt: serverTimestamp() } },
      }, { merge: true });
    } else {
      throw err;
    }
  }
};

export const addContactMessage = async (formData) => {
  await addDoc(collection(db, "contactMessages"), {
    ...formData,
    timestamp: serverTimestamp(),
  });
};

// Updates only the name and photoUrl inside the profile sub-document,
// leaving all other profile fields (headline, summary, etc.) untouched.
export const updateLinkedInProfile = async ({ name, photoUrl }) => {
  const docRef = doc(db, "portfolioData", "main");
  await updateDoc(docRef, {
    "profile.name": name,
    "profile.photoUrl": photoUrl,
  });
};
